import Vue from 'vue'

import WBox from '@/components/containers/WBox'
import WGrid from '@/components/containers/WGrid'

Vue.component('w-box', WBox)
Vue.component('w-grid', WGrid)
